export enum LoadingVariant {
  DEFAULT,
  AI,
}
